import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Theme } from "../theme";

export interface ConfigState {
  envName: string;
  isCalendlyLinkRequired: boolean;
  isAutoGoogleMeetEnabled: boolean;
  isGroupChatsEnabled: boolean;
  isSurveyForm: boolean;
  useNycIntake: boolean;
  isLinkedinLogin: boolean;
  qrSignupEnabled: boolean;
  qrProfileEnabled: boolean;
  qrBookingMentorAsBooker: boolean;
  aiMatchingPreview: boolean;
  eventIntakeEnabled: boolean;
  sendbirdAppId: string;
  tenantId: string;
  themeKey: string;
  brandName: string;
  brandingAssetVersion: number;
  runtimeTheme: Theme | null;
  /** True after first /config attempt finishes (success or failure). */
  configLoaded: boolean;
}

const initialState: ConfigState = {
  envName: 'test',
  isCalendlyLinkRequired: false,
  isAutoGoogleMeetEnabled: false,
  isGroupChatsEnabled: false,
  isSurveyForm: false,
  useNycIntake: false,
  isLinkedinLogin: false,
  qrSignupEnabled: false,
  qrProfileEnabled: false,
  qrBookingMentorAsBooker: false,
  aiMatchingPreview: false,
  eventIntakeEnabled: false,
  sendbirdAppId: '',
  tenantId: '',
  themeKey: '',
  brandName: '',
  brandingAssetVersion: 0,
  runtimeTheme: null,
  configLoaded: false,
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action: PayloadAction<Omit<ConfigState, 'configLoaded'>>) => {
      localStorage.setItem("isGroupChatsEnabled", JSON.stringify(action.payload.isGroupChatsEnabled));
      localStorage.setItem("isCalendlyLinkRequired", JSON.stringify(action.payload.isCalendlyLinkRequired));
      localStorage.setItem("isSurveyForm", JSON.stringify(action.payload.isSurveyForm));
      localStorage.setItem("useNycIntake", JSON.stringify(action.payload.useNycIntake));
      return {...state, ...action.payload, configLoaded: true}
    },
    setConfigLoaded: (state, action: PayloadAction<boolean>) => {
      state.configLoaded = action.payload;
    },
    setIsCalendlyLinkRequired: (state, action: PayloadAction<boolean>) => {
      state.isCalendlyLinkRequired = action.payload;
      localStorage.setItem("isCalendlyLinkRequired", JSON.stringify(action.payload));
    },
    setIsGroupChatsEnabled: (state, action: PayloadAction<boolean>) => {
      state.isGroupChatsEnabled = action.payload;
      localStorage.setItem("isGroupChatsEnabled", JSON.stringify(action.payload));
    },
  },
});

export const { setConfig, setConfigLoaded, setIsCalendlyLinkRequired, setIsGroupChatsEnabled } = configSlice.actions;
export default configSlice.reducer;
